import React from 'react';

const PreProduction = ({ currentUser }) => {
  return (
    <div className="bg-card-background rounded-xl p-8 border border-border-color">
      <h2 className="text-2xl font-bold text-foreground mb-6">Pre Production</h2>
      <p className="text-sidebar-foreground">Pre Production content will be implemented here.</p>
    </div>
  );
};

export default PreProduction;
